<template>
  <div class="w-full flex flex-col justify-center items-center gap-10">
    <Wrapper class="max-w-2xl">
      <h2 class="text-left text-3xl text-blue-dark py-2">
        <b>Formulario para el registro de cierre de la sesión de mediación</b>
      </h2>
      <p class="mt-4 mb-4 text-left text-xs text-gray-400">
        Complete los campos solicitados y la información detallada.
      </p>

      <div v-if="customer">
        <div class="grid grid-cols-2 gap-4 w-full mb-2">
          <BaseRadio
            ref="sesionResultType"
            name="sesionResultType"
            id="sesionResultType"
            label="Resultado de la sesión"
            :radioOptions="optionsSesionResult"
            v-model="sesionResult.type"
            :disabled="disabled"
          />
        </div>
        <template v-if="sesionResult && sesionResult.type == 1">
          <form ref="formSesionResult">
            <div class="w-full mb-5">
              <div class="grid grid-cols-2 gap-4">
                <BaseDate
                  ref="complianceDate"
                  type="text"
                  label="Fecha de cumplimiento (AAAA-MM-DD)"
                  v-model="sesionResult.fecha_cumplimiento"
                  placeholder="AAAA-MM-DD"
                  :required="true"
                />

                <BaseInput
                  ref="lugarCumplimiento"
                  type="text"
                  label="Lugar de cumplimiento"
                  v-model="sesionResult.lugar_cumplimiento"
                  :required="true"
                />
              </div>

              <BaseTextarea
                ref="pronunciamientoEntidad"
                label="Pronunciamiento de la entidad"
                placeholder="Descripción"
                v-model="sesionResult.pronunciamiento_entidad"
                maxlength="4500"
                :required="true"
              />
              <BaseTextarea
                ref="formulaArreglo"
                label="Fórmula de arreglo"
                placeholder="Descripción"
                v-model="sesionResult.formula_arreglo"
                maxlength="4500"
                :required="true"
              />
              <BaseTextarea
                ref="arregloAlcanzado"
                label="Arreglo/acuerdo alcanzado en la sesión"
                placeholder="Detalle de los términos específicos acordados para la solución de la controversia y descripción de las condiciones y requisitos que debe reunir el consumidor para el cumplimiento"
                v-model="sesionResult.propuesta_arreglo_ev"
                maxlength="4500"
                :required="true"
              />
            </div>
          </form>
        </template>
        <template v-if="sesionResult && sesionResult.type == 2">
          <div class="w-full mt-8 mb-5">
            <!-- <h2 class="mb-4 text-2xl text-left text-blue">
              <b>Respuesta a Contrapropuesta</b>
            </h2> -->

            <p class="mb-6 text-sm text-left text-gray-600">
              Seleccione el estado de cierre que mejor corresponda al resultado
              de la sesión de mediación.
            </p>

            <div class="w-full space-y-6">
              <div
                v-for="state in customStatesAgilizaDontAgree"
                :key="state.id"
                class="flex items-center mb-2"
              >
                <label class="flex items-start cursor-pointer group">
                  <input
                    type="radio"
                    name="statesAgilizaDontAgreeResponse"
                    :value="state.id"
                    v-model="statesAgilizaDontAgreeResponse"
                    :class="[
                      'mt-1 mr-4 w-4 h-4 focus:ring-2',

                      'text-blue-600 border-blue-600 focus:ring-blue-500',
                    ]"
                  />
                  <div class="flex-1 text-left">
                    <p class="font-bold text-gray-900 mb-2">
                      {{ state.name }}
                    </p>
                    <p class="text-sm text-gray-700">
                      {{ state.description }}
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </template>

        <template
          v-if="
            sesionResult && (sesionResult.type == 1 || sesionResult.type == 2)
          "
        >
          <div class="w-full mb-5">
            <DragDrop
              label="En caso de que quiera enviar soportes, adjúntelos aquí:"
              buttonLabel="SELECCIONE SUS ARCHIVOS"
              id="sesionResultFiles"
              :fileList="sesionResultFiles"
              @files-handler="setSesionResultFiles"
            />
            <p class="my-2 text-xs text-center text-gray-500">
              *Peso máximo de soportes y anexo de autorización de poder 30MB
            </p>

            <p v-if="feedback" class="text-sm text-center text-red-500 mt-4">
              {{ feedback }}
            </p>
          </div>

          <div class="flex justify-center mt-6 gap-10">
            <BaseButton
              id="cancel"
              label="CANCELAR"
              class="w-1/3"
              type="button"
              invert="true"
              @click.native="goToSessionManagement"
            />
            <BaseButton
              id="finishRegistration"
              label="GUARDAR"
              class="w-1/3"
              type="button"
              :loading="loading"
              @click.native="saveSesionResult"
            />
          </div>
        </template>
      </div>
    </Wrapper>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ComplaintForm from "@/components/Customer/Complaint/ComplaintForm";
import CustomerNatural from "@/components/Dashboard/Customers/CustomerNatural";
import CustomerLegal from "@/components/Dashboard/Customers/CustomerLegal";
import checkFileSize from "@/utils/checkFileSize";
import {
  ID_STATE_SESION_CERRADA_MEDIACION_ACUERDO,
  ID_STATE_SESION_CERRADA_MEDIACION_SIN_ACUERDO,
  ID_STATE_SESION_CERRADA_INASISTENCIA_CHAT_EV,
  ID_STATE_SESION_CERRADA_INASISTENCIA_CHAT_CF,
} from "@/core/utils/constants";
export default {
  components: {
    ComplaintForm,
    CustomerLegal,
    CustomerNatural,
  },
  props: {
    codigoQueja: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      codigo_queja: "",
      sesionResultFiles: [],
      feedback: "",
      form: {
        files_names: [],
      },
      customer: {},
      loading: false,
      disabled: false,
      modalInfoVisible: false,
      personalDataAuthorized: false,
      checkSensitiveData: 2,
      checkPersonalData: 2,
      optionsYN: [
        { id: 1, name: "Sí" },
        { id: 2, name: "No" },
      ],
      optionsSesionResult: [
        { id: 1, name: "Acuerdo" },
        { id: 2, name: "Sin acuerdo" },
      ],
      sesionResult: {
        type: null,
        fecha_cumplimiento: "",
        lugar_cumplimiento: "",
        pronunciamiento_entidad: "",
        formula_arreglo: "",
        propuesta_arreglo_ev: "",
      },
      statesAgilizaDontAgreeResponse: "",
    };
  },
  async created() {
    this.codigo_queja = this.codigoQueja || this.$route.params.codigoQueja;
  },
  computed: {
    ...mapState({
      formOptions: (state) => {
        return state.form;
      },
    }),
    customStatesAgilizaDontAgree: function () {
      return this.$store.state.form?.optionsStatesAgilizaEv?.filter(
        (stateAgiliza) =>
          stateAgiliza.id === ID_STATE_SESION_CERRADA_MEDIACION_SIN_ACUERDO ||
          stateAgiliza.id === ID_STATE_SESION_CERRADA_INASISTENCIA_CHAT_EV ||
          stateAgiliza.id === ID_STATE_SESION_CERRADA_INASISTENCIA_CHAT_CF,
      );
    },
  },
  methods: {
    setSesionResultFiles(files) {
      if (checkFileSize([...files, ...this.sesionResultFiles], 30)) {
        this.feedback =
          "Con el archivo que intenta cargar, se supera el peso máximo permitido de los anexos. Valide la información. Si requiere subir más anexos lo puede hacer con el número de radicado en el seguimiento/búsqueda de queja";
      } else {
        this.form.files_names = [];
        files.forEach((file) => {
          this.form.files_names.push(file.name);
        });

        this.sesionResultFiles = files;
        this.feedback = "";
      }
    },
    async saveSesionResult() {
      if (this.sesionResult.type == 1) {
        this.saveSesionResultAgree();
      }
      if (this.sesionResult.type == 2) {
        this.saveSesionResultDontAgree();
      }
    },
    async saveSesionResultAgree() {
      if (!this.checkFormAgree()) {
        return;
      }

      this.loading = true;
      try {
        let form = {};
        form.action_type =
          this.sesionResult.type === 1 ? "acuerdo" : "no_acuerdo";
        form.estado_id = ID_STATE_SESION_CERRADA_MEDIACION_ACUERDO;
        form.fecha_cumplimiento = this.sesionResult.fecha_cumplimiento;
        form.formula_arreglo = this.sesionResult.formula_arreglo;
        form.lugar_cumplimiento = this.sesionResult.lugar_cumplimiento;
        form.pronunciamiento_entidad =
          this.sesionResult.pronunciamiento_entidad;
        form.propuesta_arreglo_ev = this.sesionResult.propuesta_arreglo_ev;

        let { error, data } = await this.$api.setSesionResult(
          form,
          this.sesionResultFiles,
          this.codigo_queja,
        );
        if (error) {
          this.showError(error);
          return;
        }
        if (data) {
          this.showToast("success", data.message);
          this.goToSessionManagement();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async saveSesionResultDontAgree() {
      if (!this.checkFormDontAgree()) {
        return;
      }

      this.loading = true;
      try {
        let form = {};
        form.action_type =
          this.sesionResult.type === 1 ? "acuerdo" : "no_acuerdo";
        form.estado_id = this.statesAgilizaDontAgreeResponse;

        let { error, data } = await this.$api.setSesionResult(
          form,
          this.sesionResultFiles,
          this.codigo_queja,
        );
        if (error) {
          this.showError(error);
          return;
        }
        if (data) {
          this.showToast("success", data.message);
          this.goToSessionManagement();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    goToSessionManagement() {
      this.$router.push(`/dashboard/complaints-agiliza/sessions`);
    },

    checkFormAgree() {
      this.feedback = "";
      let valid = false;
      let refs = { ...this.$refs };

      for (let ref in refs) {
        if (refs[ref] && refs[ref].required && refs[ref].value === "") {
          let y =
            refs[ref].$el.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo(0, y);
          refs[ref].setInvalid(true);
          this.feedback =
            "Se deben completar todos los campos obligatorios antes de continuar.";
          return valid;
        }
      }

      valid = true;
      this.feedback = "";
      return valid;
    },
    checkFormDontAgree() {
      this.feedback = "";
      let valid = false;
      let refs = { ...this.$refs };

      if (this.statesAgilizaDontAgreeResponse === "") {
        this.feedback =
          "Debe seleccionar el estado de cierre sin acuerdo que mejor refleje el resultado de la sesión de mediación.";
        return false;
      }

      valid = true;
      this.feedback = "";
      return valid;
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
    onCancelModal() {
      this.$router.go(-2);
    },
    onCancel() {
      this.$router.go(-1);
    },
  },
  watch: {
    sesionResult: {
      handler() {
        this.feedback = "";
      },
      deep: true,
    },
    statesAgilizaDontAgreeResponse: {
      handler() {
        this.feedback = "";
      },
      deep: true,
    },
  },
};
</script>
